module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGe6a8a6b1470ed19dc8f309c79ce746ce.e6a8a6b1.png";